import React from 'react'
import Wrapper from './Wrapper.js'

export default () => (
	<Wrapper>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 884.309 884.309">
			<g>
				<path d="M26.504,248c0,113.7,0,439.8,0,439.8c0,19.7,11.6,37.6,29.6,45.7l333.4,148.6c16.5,7.4,35.2-4.7,35.2-22.8v-456
					c0-9.9-5.8-18.8-14.8-22.8l-348.2-155.4C45.104,217.8,26.504,229.9,26.504,248z M214.904,471.899
					c21.6-1.399,40.9,26.601,43.2,62.5c2.301,35.9-13.399,66.101-35,67.4c-21.6,1.4-40.9-26.6-43.2-62.5
					C177.604,503.399,193.304,473.2,214.904,471.899z"/>
				<path d="M857.804,687.7c0,0,0-326.101,0-439.8c0-18.1-18.7-30.2-35.2-22.8l-348.1,155.4c-9,4-14.8,13-14.8,22.8v456
					c0,18.1,18.7,30.2,35.2,22.8l333.399-148.7C846.205,725.399,857.804,707.5,857.804,687.7z M626.405,675.7
					c-2.301,35.899-21.601,63.8-43.2,62.5c-21.601-1.4-37.2-31.601-35-67.4c2.3-35.9,21.6-63.8,43.2-62.5
					C613.104,609.7,628.705,639.899,626.405,675.7z M774.205,422.3c-2.3,35.9-21.601,63.8-43.2,62.5c-21.6-1.4-37.2-31.6-35-67.4
					c2.3-35.899,21.6-63.8,43.2-62.5C760.804,356.2,776.504,386.399,774.205,422.3z"/>
				<path d="M79.104,194.6l352.9,157.4c6.5,2.899,13.9,2.899,20.4,0l352.899-157.4c20-8.9,19.7-37.4-0.5-45.9L461.604,3.9
					c-6.199-2.6-12.8-3.9-19.399-3.9c-6.601,0-13.2,1.3-19.4,3.9l-343.3,144.8C59.404,157.2,59.104,185.7,79.104,194.6z
					M632.604,130.3c35.9-0.2,65.101,17.3,65.2,39c0.101,21.7-28.899,39.5-64.8,39.6c-35.9,0.2-65.1-17.3-65.2-39
					C567.705,148.2,596.705,130.4,632.604,130.3z M442.004,130.3c35.9-0.2,65.1,17.3,65.2,39c0.1,21.7-28.9,39.5-64.8,39.6
					c-35.9,0.2-65.101-17.3-65.2-39C377.104,148.2,406.104,130.4,442.004,130.3z M251.405,130.3c35.899-0.2,65.1,17.3,65.199,39
					c0.101,21.7-28.899,39.5-64.8,39.6c-35.9,0.1-65.1-17.3-65.2-39C186.504,148.2,215.504,130.4,251.405,130.3z"/>
			</g>
		</svg>
	</Wrapper>
)



// WEBPACK FOOTER //
// ./src/ui/icons/Dice.js